import { createApp } from "vue";
import { gsap } from "gsap";
import { decode } from 'html-entities';
import axios from "axios";

export default function initProjectArchive(isMobile, isTouch) {
  if (!document.querySelector(".project-archive") || projectArchiveApp) return;
  var projectArchiveApp = createApp({
    el: "#projects",
    data() {
      return {
        projects,
        industries: [
          {
            slug: null,
            name: "All",
          },
        ],
        sortOptions: [
          {
            slug: "alphaasc",
            name: "A-Z",
          },
          {
            slug: "datedesc",
            name: "Most Recent",
          },
          {
            slug: "sqftasc",
            name: "Highest Square Footage",
          },
        ],
        selectedIndustry: {
          name: "",
          slug: null,
        },
        selectedSort: {
          name: "",
          slug: null,
        },
        sortOptionsOpen: false,
        industryOptionsOpen: false,
      };
    },
    mounted() {
      var vm = this;
      vm.projects.forEach((project) => project.industries && project.industries.length && 
        project.industries.forEach((industry) => {
          if (
            vm.industries.filter((i) => i.name === industry.name).length === 0
          )
            vm.industries.push({
              slug: industry.slug,
              name: decode(industry.name),
            });
        })
      );
    },
    computed: {
      computedProjects: function () {
        var vm = this;
        var projects = vm.projects;
        if (vm.selectedIndustry.slug) {
          projects = projects.filter(
            (p) =>
              (p.industries?.length) ? p.industries.filter((i) => i.slug === vm.selectedIndustry.slug)
                .length > 0 : false
          );
        }
        if (vm.selectedSort.slug) {
          switch (vm.selectedSort.slug) {
            case "alphaasc":
              projects = projects.sort((a, b) => {
                if (b.title < a.title) return 1;
                if (b.title > a.title) return -1;
                return 0;
              });
              break;
            case "datedesc":
              projects = projects.sort(
                (a, b) => new Date(b.date) - new Date(a.date)
              );
              break;
            case "sqftasc":
              projects = projects.sort((a, b) => b.sqft - a.sqft);
              break;
            default:
              break;
          }
        }

        return projects;
      },
    },
    methods: {
      toggleIndustryDropdown: function (section) {
        if (this.industryOptionsOpen) {
          gsap.set(
            ".project-archive__header--selects--select--options--industry",
            {
              autoAlpha: 0,
            }
          );
        } else {
          //Had to make the dropdowns position fixed to the body for the z-indexes to work out, this is setting its position each time it opens
          var button = document.querySelector(
            ".project-archive__header--selects--select--industry"
          );
          var buttonBottom = button.getBoundingClientRect().bottom;
          var buttonLeft = button.getBoundingClientRect().left;
          var buttonWidth = button.getBoundingClientRect().width;

          gsap.set(
            ".project-archive__header--selects--select--options--industry",
            {
              left: buttonLeft,
              top: buttonBottom,
              width: buttonWidth,
              autoAlpha: 1,
            }
          );
        }
        this.industryOptionsOpen = !this.industryOptionsOpen;
      },
      toggleSortDropdown: function (section) {
        if (this.sortOptionsOpen) {
          gsap.set(".project-archive__header--selects--select--options--sort", {
            autoAlpha: 0,
          });
        } else {
          var button = document.querySelector(
            ".project-archive__header--selects--select--sort"
          );
          var buttonBottom = button.getBoundingClientRect().bottom;
          var buttonLeft = button.getBoundingClientRect().left;
          var buttonWidth = button.getBoundingClientRect().width;

          gsap.set(".project-archive__header--selects--select--options--sort", {
            left: buttonLeft,
            top: buttonBottom,
            width: buttonWidth,
            autoAlpha: 1,
          });
        }
        this.sortOptionsOpen = !this.sortOptionsOpen;
      },
    },
  });

  projectArchiveApp.mount("#projects");
}
